import { mixed, number, object, string } from "yup";

export default object({
  bottom_quartile: number().max(100),
  comparison_name: string().nullable(),
  comparison: number()
    .max(100)
    .nullable(),
  max: number().max(100),
  median: number().max(100),
  min: number().max(100),
  name: string(),
  top_quartile: number().max(100),
  headline: string(),
  description: string(),
  section_title: string(),
  section_title: string(),
  benchmark_type: string().nullable(),
  primary_factor_narrative: string().nullable()
}).noUnknown({ message: "Unknown keys" });
